import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const INVOICE: AppRouteRecordRaw = {
  path: '/invoice',
  name: 'invoice',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '真实充电开票管理',
    icon: 'icon-file',
    requiresAuth: true,
    order: 10,
  },
  children: [
    {
      path: 'list',
      alias: '/invoice/index',
      name: 'InvoiceList',
      component: () => import('@/views/invoice/index.vue'),
      meta: {
        locale: '发票列表',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'auto-config',
      name: 'InvoiceAutoConfig',
      component: () => import('@/views/system/invoice-auto-config/index.vue'),
      meta: {
        locale: '自动开票配置',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default INVOICE;
